module.exports = __webpack_public_path__ + "img/mjjh2.c80a47cf.jpg";